import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { addBusiness, updateDeveloper } from "../services/developerApi";
import { useMutation, useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { Spin } from "antd";
import { UserAddOutlined } from "@ant-design/icons";
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import AddPaymentForm from "./addPaymentForm";
import { PaymentContext } from "../../../common/PaymentContext";
import { createPaymentAccountMobile, createPaymentAccountCardBank } from "../services/paymentApi";
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';

const AddEditPaymentModal = ({ modal, setModal, toggle, selectedPaymentAccount, currentuser }) => {

  const queryClient = useQueryClient();
  const marchandId = currentuser?.user?.id;
  const { phoneNumber, paymentMethods, cardBankNumber, expirationDate, cvv } = useContext(PaymentContext);

  const modalTitle = selectedPaymentAccount ? "Édition" : `Ajout`;

  const merchandId = currentuser?.user?.id;

  const mutationCreateAccountMobile = useMutation(createPaymentAccountMobile, {
    onSuccess: () => {
      toast.success("Compte créé avec succes");
    },
    onError: (error) => {
      console.error("Error while creating account :", error || error?.message);
      toast.error("Erreur creation", error || error?.message);
    }
  })

  const mutationCreateAccountCardBank = useMutation(createPaymentAccountCardBank, {
    onSuccess: () => {
      toast.success("Compte créé avec succès");
    },
    onError: (error) => {
      console.error("Error while creating account :", error || error?.message);
      toast.error("Erreur de création du compte");
    }
  })

  const handleSubmit = (e) => {
    e.preventDefault();
    if (phoneNumber) {
      const newAccount = {
        phoneNumber: phoneNumber,
        ownerId: merchandId,
        walletId: paymentMethods[0],
        merchantCode: '0000',
      };
      const requestData = {
        merchandId,
        newAccount
      }
      mutationCreateAccountMobile.mutate(requestData);
    } else if(cardBankNumber) {
      const newAccount = {
        cardNumber: cardBankNumber,
        ownerId: merchandId,
        cardBankId: 1,
      }
      const requestData = {
        merchandId,
        newAccount
      }
      mutationCreateAccountCardBank.mutate(requestData);
    }

  }

  const returnFooterButton = () => {
    if (selectedPaymentAccount) {
      return (
        <Button type="submit" className="btn btn-soft-success">
          Modifier
        </Button>
      )
    } else {
      return (<Button type="submit" className="btn btn-soft-success">
        Ajouter
      </Button>)
    }
  }

  return (
    <Modal
      id="showModalClient"
      isOpen={modal}
      toggle={toggle}
      centered
      backdrop={"static"}
      style={{ maxWidth: "700px", maxHeight: "800px" }}
    >
      <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
        {modalTitle} d'un compte de versement <UserAddOutlined />
      </ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <Row>
            <AddPaymentForm />
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={() => setModal(false)}>
            Annuler
          </Button>
          {returnFooterButton()}
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AddEditPaymentModal;
